<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Dedication"> </h1>
<p class="sectiontop" style="text-align: center;">Especially for Richard.<br/>
  A big thank you to Nancy Pirri and Jill Barnett.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?3eb94978